<template>
    <md-card class="form-container">

        <div class="delete-container">
            <h4 class="text-left flex-siblings">
                <label>サービス情報</label>
            </h4>

            <div class="flex-siblings-responsive">
                <h4 class="theme-primary-text ">英辞郎 on the WEB Pro Lite</h4>
                <h4 class="text-secondary">無料</h4>
            </div>
            <br>
        </div>
        <div class="delete-container">
            <h4 class="text-left">
                <label>アカウント削除</label>
            </h4>
            <p class="text-left"> アカウントを削除しますか。
                <br><br>「英辞郎 on the WEB Pro」のアプリ内購入を行ったことがある方は、手続きを進める前に、サブスクリプション（定期購入）が停止されていることを、各ストアでご確認ください。
                <br><br>アカウントを削除すると、登録されたメールアドレスIDとパスワード、検索履歴、単語帳が永久に失われます。 
            </p>
            <md-card-actions class="pt-10 pb-10">
                <slot name="button"></slot>
            </md-card-actions>
        </div>
    </md-card>
</template>
<script>
export default {
    data() {
        return {
            isChecked: false,
        };
    },
};
</script>